import React from "react";
import { useSelector, useDispatch } from 'react-redux'


/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import subDays from "date-fns/subDays"
import addDays from "date-fns/addDays"
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// SemanticUI components
import { Form, FormGroup, FormInput, FormSelect, Container, Header, HeaderContent, Icon, FormField, Grid, GridRow, GridColumn } from 'semantic-ui-react';

// Redux slices
import { setContractData } from "./contractSlice";

// Components
import { optionsCurrency } from './systemdata';
import Max2ContractSeasonRoomsRooms from "./seasonrooms_rooms";
import Max2ContractSeasonRoomsSeasons from "./seasonrooms_seasons";
import Max2ContractSeasonRoomsPrices from "./seasonrooms_prices";
import Max2ContractSeasonRoomsBoards from "./seasonrooms_boards";

// Styles
import "react-datepicker/dist/react-datepicker.css";
import './contract.css';


registerLocale('de', de);
setDefaultLocale('de');





/**
 * 
 * @param {bool} editMode 
 * @returns 
 */
const Max2ContractSeasonRooms = ({editMode}) => {
  // global State
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);

  // Edit mode?
  const readOnly = editMode ? false : true;

  const startDate = Contract.Period.Start ? new Date(Contract.Period.Start) : new Date();
  const endtDate = Contract.Period.End ? new Date(Contract.Period.End) : new Date();


  if (readOnly) {
    return (
      <>
      <Header as='h4'>Allgemeines</Header>
      <Grid>
        <GridRow className='masterdata_ro_row'>
          <GridColumn width={4} className='masterdata_ro_label' textAlign='right'>Preise, inkl. Steuern + Gebühren, in</GridColumn>
          <GridColumn width={12}>{optionsCurrency.map((curr) => { return curr.value == Contract.Currency ? curr.text : <></> })}</GridColumn>
        </GridRow>
        <GridRow className='masterdata_ro_row'>
          <GridColumn width={4} className='masterdata_ro_label' textAlign='right'>Vertragslaufzeit von</GridColumn>
          <GridColumn width={12}>{format(startDate, "dd.MM.yyyy")}</GridColumn>
        </GridRow>
        <GridRow className='masterdata_ro_row'>
          <GridColumn width={4} className='masterdata_ro_label' textAlign='right'>Vertragslaufzeit bis</GridColumn>
          <GridColumn width={12}>{format(endtDate, "dd.MM.yyyy")}</GridColumn>
        </GridRow>
      </Grid>
  
      <br />
      <br />
  
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>Zimmer / Zimmerbelegung</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractSeasonRoomsRooms editMode={editMode} />
      </Container>
  
      <br />
      <br />
  
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>Saisonzeiten</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractSeasonRoomsSeasons editMode={editMode} />
      </Container>
      
      <br />
      <br />
  
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>Zimmerpreise, Kontingente & Ermäßigungen</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractSeasonRoomsPrices editMode={editMode} />
      </Container>
  
      <br />
      <br />
      
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>Verpflegungszuschläge & Ermäßigungen</HeaderContent>
      </Header>
      <Container className="large">
        {<Max2ContractSeasonRoomsBoards editMode={editMode} />}
      </Container>
  
      </>
    );
  }


  return (
    <>
    <Header as='h4'>
      <Icon name='angle right' />
      <HeaderContent>Allgemeines</HeaderContent>
    </Header>
    <Container>
      <Form>
        <FormSelect search selection readOnly={readOnly} value={Contract.Currency} label='Preise, inkl. Steuern + Gebühren, in' options={optionsCurrency} placeholder='bitte w&auml;hlen' />
        <FormGroup>
          <FormField>
            <DatePicker
              showWeekNumbers
              selected    = {startDate}
              startDate   = {startDate}
              endDate     = {endtDate}
              dateFormat  = "dd.MM.yyyy"
              placeholder = 'TT.MM.JJJJ'
              readOnly    = {readOnly}
              onChange    = {(date) => dispatch(setContractData({target: 'Period.Start', value: format(date, "yyyy-MM-dd")}))}
              customInput = {<FormInput label='Vertragslaufzeit von' icon='calendar alternate' iconPosition='left' placeholder='TT.MM.JJJJ'/>}
            />
          </FormField>
          <FormField>
            <DatePicker
              showWeekNumbers
              selected    = {endtDate}
              startDate   = {startDate}
              endDate     = {endtDate}
              minDate     = {startDate}
              dateFormat  = "dd.MM.yyyy"
              placeholder = 'TT.MM.JJJJ'
              readOnly    = {readOnly}
              onChange    = {(date) => dispatch(setContractData({target: 'Period.End', value: format(date, "yyyy-MM-dd")}))}
              customInput = {<FormInput label='Vertragslaufzeit bis' icon='calendar alternate' iconPosition='left' placeholder='TT.MM.JJJJ'/>}
              excludeDateIntervals = {[
                { start: subDays(new Date("1970-01-01"), 5), end: addDays(startDate, 5) },
              ]}
            />
          </FormField>
        </FormGroup>
      </Form>
    </Container>

    <br />
    <br />

    <Header as='h4'>
      <Icon name='angle right' />
      <HeaderContent>Zimmer / Zimmerbelegung</HeaderContent>
    </Header>
    <Container className="large">
      <Max2ContractSeasonRoomsRooms editMode={editMode} />
    </Container>

    <br />
    <br />

    <Header as='h4'>
      <Icon name='angle right' />
      <HeaderContent>Saisonzeiten</HeaderContent>
    </Header>
    <Container className="large">
      <Max2ContractSeasonRoomsSeasons editMode={editMode} />
    </Container>
    
    <br />
    <br />

    <Header as='h4'>
      <Icon name='angle right' />
      <HeaderContent>Zimmerpreise, Kontingente & Ermäßigungen</HeaderContent>
    </Header>
    <Container className="large">
      <Max2ContractSeasonRoomsPrices editMode={editMode} />
    </Container>

    <br />
    <br />
    
    <Header as='h4'>
      <Icon name='angle right' />
      <HeaderContent>Verpflegungszuschläge & Ermäßigungen</HeaderContent>
    </Header>
    <Container className="large">
      {<Max2ContractSeasonRoomsBoards editMode={editMode} />}
    </Container>

    </>
  );
}

export default Max2ContractSeasonRooms;